import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

export default function PageTracking() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const pagePath = `${pathname}${search}`;

    trackPageView({
      pageTitle: document.title,
      pagePath,
      pageLocation: window.location.href,
    });
  }, [pathname, search]);

  return null;
}